export default {"src":"/_next/static/media/sejfa-logo.664c55cb.svg","height":34,"width":80,"blurWidth":0,"blurHeight":0};